import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

function isAuthRouteName(name, path) {
  return name === "Login" || path === "/login";
}

export function useDarkMode() {
  const store = useStore();
  const route = useRoute();

  const isDarkMode = computed(() => store.getters["darkMode/isDarkMode"]);
  const authRoute = computed(() => isAuthRouteName(route.name, route.path));
  const darkModeActive = computed(() => isDarkMode.value && !authRoute.value);

  const themeClass = computed(() =>
    darkModeActive.value ? "fd-dark-mode" : "fd-light-mode"
  );

  watch(
    darkModeActive,
    (on) => {
      document.documentElement.classList.toggle("fd-dark-mode", on);
    },
    { immediate: true }
  );

  function toggleDarkMode() {
    store.commit("darkMode/toggleDarkMode");
  }

  return {
    isDarkMode,
    themeClass,
    toggleDarkMode,
  };
}
